export default __webpack_public_path__ + "static/media/taste_dex.5edbace8.jpeg";